import {
  Box,
  Text,
  Image,
  VStack,
  HStack,
} from "@chakra-ui/react";

const OurAwards = ({ fallbackAwards }) => {
  // Fallback award data with images
  

  // Use API data if available, otherwise use fallback awards
  const awards = fallbackAwards;
  
  // Split awards into rows for display
  const firstRowAwards = awards.slice(0, 3);
  const secondRowAwards = awards.slice(3, 6);

  return (
    <Box px={{ base: "20px", md: "60px", lg: "120px" }} py={{ base: "15px", md: "20px" }}>
      
      {/* Awards Layout */}
      <VStack spacing={{ base: 1, md: 2, lg: 3 }} mx="auto">
        {/* First Row - 3 Images */}
        <HStack 
          spacing={{ base: 4, md: 6, lg: 8 }} 
          justify={{ base: "center", md: "center" }} 
          flexWrap="wrap"
          gap={{ base: 4, md: 6, lg: 8 }}
          w="100%"
        >
          {firstRowAwards.map((award, index) => (
            <Box
              key={index}
              w={{ base: "140px", sm: "180px", md: "220px", lg: "280px", xl: "300px" }}
              h={{ base: "140px", sm: "180px", md: "220px", lg: "280px", xl: "300px" }}
              flexShrink={0}
            >
              {award.url ? (
                <Image
                  src={award.url}
                  alt={award.alternativeText || `Award ${index + 1}`}
                  w="100%"
                  h="100%"
                  objectFit="contain"
                  transition="transform 0.3s ease"
                  _hover={{ transform: "scale(1.05)" }}
                  onError={(e) => {
                    console.error('Award image failed to load:', award.url);
                    e.target.style.display = 'none';
                  }}
                />
              ) : (
                <Box
                  w="100%"
                  h="100%"
                  bg="gray.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="md"
                >
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.500">No Award Image</Text>
                </Box>
              )}
            </Box>
          ))}
        </HStack>

        {/* Second Row - 2 Images */}
        <HStack 
          spacing={{ base: 4, md: 6, lg: 8 }} 
          justify="center" 
          flexWrap="wrap"
          gap={{ base: 4, md: 6, lg: 8 }}
          w="100%"
        >
          {secondRowAwards.map((award, index) => (
            <Box
              key={index}
              w={{ base: "140px", sm: "180px", md: "220px", lg: "280px", xl: "300px" }}
              h={{ base: "140px", sm: "180px", md: "220px", lg: "280px", xl: "300px" }}
              flexShrink={0}
            >
              {award.url ? (
                <Image
                  src={award.url}
                  alt={award.alternativeText || `Award ${index + 4}`}
                  w="100%"
                  h="100%"
                  objectFit="contain"
                  transition="transform 0.3s ease"
                  _hover={{ transform: "scale(1.05)" }}
                  onError={(e) => {
                    console.error('Award image failed to load:', award.url);
                    e.target.style.display = 'none';
                  }}
                />
              ) : (
                <Box
                  w="100%"
                  h="100%"
                  bg="gray.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="md"
                >
                  <Text fontSize={{ base: "xs", md: "sm" }} color="gray.500">No Award Image</Text>
                </Box>
              )}
            </Box>
          ))}
        </HStack>
      </VStack>
    </Box>
  );
};

export default OurAwards;
